import React from "react";
import { Bar } from "react-chartjs-2";

const DailyComplains = ({ labels, values, title }) => {
  const totalComplains = values?.reduce((sum, obj) => sum + obj, 0);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: `Total = ${totalComplains}`,
      },
      {
        label: title,
        data: values,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
  };

  return (
    <>
      <Bar data={chartData} options={chartOptions} />
    </>
  );
};

export default DailyComplains;
